export type AgeOption = { label: string; value: number };
type AdsetAge = { t_age?: { min: number; max: number } | null };

export const ageOptions: AgeOption[] = Array.from({ length: 53 }, (_, i) => {
  const age = i + 13;
  return { label: age === 65 ? "65+" : `${age}`, value: age };
});

export const isAdsetWithinAgeRange = (adset: AdsetAge, ageMin: number, ageMax: number): boolean =>
  (adset.t_age?.min ?? NaN) >= ageMin && (adset.t_age?.max ?? NaN) <= ageMax;
